const isDemo = process.env.REACT_APP_THEME === 'demo';

const styles = (theme) => ({
  root: {
    fontFamily: isDemo ? 'inherit' : 'Questrial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    height: '100%',
    width: '100%',
    padding: '16px 24px',
  },
  background: {},
  content: {
    display: 'flex',
    height: 'calc(100% - 52px)',
    width: '100%',
  },
  left: {
    width: 224,
    paddingRight: 24,
    height: '100%',
    overflowY: 'auto',
    flexShrink: 0,
  },
  progress: {},
  textField: {
    width: '280px',
    marginRight: 8,
  },
  formControl: {},
  header: {
    display: 'flex',
  },
  mountains: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    zIndex: -1,
  },
  formFilter: {
    flex: 1.5,
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
  },
  contentDiv: {
    flex: 9,
    marginLeft: '50px',
    overflow: 'auto',
    marginTop: '-65px',
  },
  loadingWrapper: {
    height: 300,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  viewRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: theme.spacing.unit * 2,
  },
  colorSwitchBase: {
    color: theme.palette.success.main,
    '&$colorChecked': {
      color: theme.palette.success.light,
      '& + $colorBar': {
        backgroundColor: theme.palette.success.main,
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  errorRow: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    gap: 16,
  },
  errorMsg: {
    fontSize: 16,
    textAlign: 'center',
    flexGrow: 1,
  },
  disclaimer: {
    fontSize: 11,
    marginTop: 16,
  },
  viewScore: {
    fontSize: 18,
    marginTop: 18,
    marginBottom: 12,
  },
  statCardRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 18,
    marginBottom: 22,
  },
  statCard: {
    background: '#fff',
    padding: '18px 22px',
    borderRadius: 16,
    boxShadow: '0 6px 20px rgba(58,166,185,0.10)',
    border: '1px solid rgba(191,247,255,0.6)',
    minWidth: 140,
  },
  statNumber: {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: '#2c3e40',
    lineHeight: 1.1,
  },
  statNumberGood: {
    color: '#16a34a',
  },
  statNumberWarn: {
    color: '#d97706',
  },
  statLabel: {
    fontSize: '0.82rem',
    color: '#7c8a8d',
    marginTop: 2,
  },
  pgSubjectGroup: {
    marginBottom: 6,
  },
  pgSubjectHeading: {
    fontSize: '1rem',
    fontWeight: 700,
    color: '#2c3e40',
    marginBottom: 10,
  },
  pgSubjectCount: {
    fontSize: '0.82rem',
    fontWeight: 400,
    color: '#7c8a8d',
  },
});

export default styles;
